module.exports = __webpack_public_path__ + "static/media/wind_speed_comparative_per_month.834de659.svg";